$demo_app $mol_page
	title \$mol × GraphQL fragments
	body /
		<= Greeting $mol_paragraph
			title <= greeting \
		<= Pinned $mol_paragraph
			title <= pinned_title \
		<= Static_panel $mol_paragraph
			title <= static_title \
		<= Live $demo_note_live
		<= Note_list $mol_list
			rows <= note_rows /
	Note_card* $demo_note_card
		note_ref <= card_ref* null
